import { SortingOrder } from "../models";
import { VerwerkingsoverzichtFilter, VerwerkingsoverzichtResults } from "../models/verwerkingsoverzicht";
import { BaseClient } from "./baseClient";

export interface IVerwerkingsoverzichtApi {
  getVerwerkingsoverzicht(
    start: number,
    pagesize: number,
    order?: SortingOrder,
    filters?: VerwerkingsoverzichtFilter[]
  ): Promise<VerwerkingsoverzichtResults>;
}

const verwerkingsoverzichtHeaders = () =>
  new Headers({
    "Content-type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  });

export class VerwerkingsoverzichtApi extends BaseClient implements IVerwerkingsoverzichtApi {
  constructor() {
    super(verwerkingsoverzichtHeaders(), process.env.REACT_APP_VERWERKINGSOVERZICHT_API_ENDPOINT as string);
  }

  getVerwerkingsoverzicht = async (
    start: number,
    pagesize: number,
    order: SortingOrder = "desc",
    filters: VerwerkingsoverzichtFilter[] = []
  ) => {
    const params = new URLSearchParams({ start: String(start), pagesize: String(pagesize), order });
    filters.forEach((filter) => params.append("filters", filter));
    const { json } = await this.api<VerwerkingsoverzichtResults>(
      "publicaties",
      undefined,
      "GET",
      undefined,
      params.toString()
    );
    return json as VerwerkingsoverzichtResults;
  };
}
